/**
 * Textos da assinatura do laudo com certificado digital pelo Assinador SERPRO (E164.F2, GUS-113,
 * ADR-0113): o estado do programa no computador do perito, a orientação de instalação, os botões
 * por papel, o andamento, as recusas e a lista "Assinar pendentes" do responsável técnico.
 */
export const ptBRAssinaturaIcp = {
  antesTitulo: 'Antes da assinatura',
  antesTexto:
    'Confirme a revisão acima. A assinatura usa o seu certificado digital no Assinador SERPRO, neste computador, e vale para esta versão do laudo.',
  assinarComoAssistenciaTecnica: 'Assinar como assistente técnica forense',
  assinarComoResponsavel: 'Assinar como responsável técnico',
  assinadorVerificando: 'Procurando o Assinador SERPRO neste computador…',
  assinadorConectado: 'Assinador SERPRO conectado.',
  assinadorAusente: 'O Assinador SERPRO não respondeu neste computador.',
  verificarDeNovo: 'Verificar de novo',
  comoInstalar: 'Como instalar o Assinador SERPRO',
  passosDaInstalacao: [
    'Baixe o Assinador SERPRO na página oficial e instale. A instalação pede um usuário administrador do computador.',
    'Abra o programa. O ícone dele fica perto do relógio enquanto ele estiver no ar.',
    'Conecte o dispositivo do certificado digital (o pendrive do certificado).',
    'Na primeira vez, se o navegador pedir, permita o "acesso à rede local" para este site.',
    'Volte aqui e clique em "Verificar de novo".',
  ],
  paginaOficial: 'Abrir a página oficial do Assinador SERPRO',
  preparando: 'Preparando o laudo para assinar…',
  noAssinador:
    'Continue no Assinador SERPRO: escolha o seu certificado digital e digite a senha (PIN).',
  conferindo: 'Conferindo a assinatura…',
  assinadaNaPrimeiraEtapa:
    'Assinatura registrada. O laudo segue para a assinatura do responsável técnico.',
  assinadaFinal: 'Laudo assinado com certificado digital e entregue.',
  reconciliada: 'A assinatura já estava registrada. Nada foi assinado de novo.',
  semCpf:
    'Cadastre o seu CPF no perfil antes de assinar. A assinatura só vale com o certificado do mesmo CPF.',
  cancelado: 'Assinatura cancelada no Assinador. Nada foi assinado.',
  tempoEsgotado:
    'O Assinador não respondeu a tempo. Nada foi assinado. Confira o programa e tente de novo.',
  assinadorRecusou: 'O Assinador não assinou o laudo: {motivo}. Nada foi registrado.',
  outrasFormas: 'Outras formas de assinar',
  assinarSemCertificado: 'Assinar sem certificado digital',
  semCertificadoAviso:
    'Use só se o certificado digital falhar. O laudo sai com a assinatura registrada no sistema, sem certificado ICP-Brasil.',
  recusa: {
    CPF_NAO_CADASTRADO:
      'Cadastre o seu CPF no perfil antes de assinar. A assinatura só vale com o certificado do mesmo CPF.',
    SEM_RESPONSAVEL_TECNICO:
      'A plataforma ainda não tem responsável técnico marcado. Peça ao titular para marcar em Usuários.',
    CPF_DE_OUTRA_PESSOA:
      'O certificado escolhido é de outro CPF. Assine com o seu certificado digital.',
    CERTIFICADO_SEM_CPF: 'O certificado escolhido não traz CPF. Assine com o seu e-CPF.',
    // E220.F1 (owner, 03/11): o responsável assina depois da assistente, nunca por cima.
    ASSISTENTE_AINDA_NAO_ASSINOU:
      'A assistente técnica preparou este laudo e ainda não assinou. Assine depois dela.',
    CADEIA_NAO_CONFERE:
      'O certificado escolhido não é reconhecido como ICP-Brasil. Assine com o seu e-CPF ou avise a equipe técnica.',
    PDF_FORA_DA_VERSAO_EMITIDA:
      'O arquivo assinado não é a versão emitida para assinatura. Assine de novo a partir desta tela.',
    SELO_SOBRE_O_TEXTO:
      'O selo da assinatura ficou por cima de uma parte já impressa do laudo. Ajuste a posição do selo no Assinador para uma área em branco e assine de novo.',
    SEM_ASSINATURA_NOVA: 'O arquivo voltou sem a assinatura. Assine de novo.',
    ASSINATURA_NAO_INTEGRA: 'A assinatura não confere com o arquivo. Assine de novo.',
    ASSINATURA_ANTERIOR_ALTERADA:
      'O arquivo foi alterado depois da primeira assinatura. Peça uma nova preparação do laudo.',
    PDF_ILEGIVEL: 'O arquivo assinado não pôde ser lido. Assine de novo.',
    NAO_E_A_VEZ_DESTE_PERITO: 'Esta assinatura não é a sua vez neste laudo.',
    ASSINATURA_SUPERADA:
      'Este laudo foi preparado de novo depois. Atualize a tela e assine a versão nova.',
    SEM_ASSINATURA_EM_CURSO: 'Este laudo não tem assinatura em andamento.',
    RESULTADO_DESATUALIZADO:
      'O resultado do caso mudou depois da preparação. Prepare e assine de novo.',
    LAUDO_JA_ASSINADO: 'Este laudo já está assinado.',
    ASSINATURA_NAO_CONFERIDA:
      'A assinatura não foi registrada: a conferência da assinatura não aprovou o laudo desta versão. Abra o caso e confira o "Próximo passo".',
    SAIDAS_NAO_REVISADAS:
      'O exame desta versão ainda não foi marcado como revisado. Abra "Conferir e assinar" no caso e revise o exame.',
  } as Record<string, string>,
  pendentes: {
    titulo: 'Assinaturas pendentes do responsável técnico',
    texto: 'Laudos com a primeira assinatura já feita, à espera da sua.',
    vazio: 'Nenhum laudo à espera da sua assinatura.',
    carregando: 'Carregando as assinaturas pendentes…',
    erro: 'Não foi possível carregar as assinaturas pendentes. Tente novamente.',
    assinarTodos: 'Assinar pendentes ({n})',
    andamento: 'Assinando {i} de {n}: {codigo}…',
    concluido: '{n} laudo(s) assinado(s) e entregue(s).',
    interrompido: 'Parou em {codigo}: {motivo}',
    primeiraAssinatura: 'Assinado por {nome} em {quando}',
  },
} as const;
